import { Container } from "pixi.js";

export class PIXIContainerRef {
    current: Container
    centered: boolean = false
}